export default __webpack_public_path__ + "static/media/parrot.bd94b1b2.jpg";